import { createAction, props } from '@ngrx/store';
import { UserQueryDto } from '../../../api/models/user-query-dto';
import { UserUpdateCommand } from '../../../api/models/user-update-command';

export enum UserActionTypes {
  READ_ALL = '[USER] READ_ALL',
  READ_ALL_SUCCESS = '[USER] READ_ALL_SUCCESS',
  READ_ALL_FAILED = '[USER] READ_ALL_FAILED',

  CREATE_USER = '[USER] CREATE_USER',
  CREATE_USER_SUCCESS = '[USER] CREATE_USER_SUCCESS',
  CREATE_USER_FAILED = '[USER] CREATE_USER_FAILED',

  UPDATE_USER = '[USER] UPDATE_USER',
  UPDATE_USER_SUCCESS = '[USER] UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILED = '[USER] UPDATE_USER_FAILED',

  ADMIN_UPDATE_USER = '[USER] ADMIN_UPDATE_USER',
  ADMIN_UPDATE_USER_SUCCESS = '[USER] ADMIN_UPDATE_USER_SUCCESS',
  ADMIN_UPDATE_USER_FAILED = '[USER] ADMIN_UPDATE_USER_FAILED',

  RESET = '[USER] RESET',
}

export const loadUsers = createAction(UserActionTypes.READ_ALL);
export const readAllSuccess = createAction(UserActionTypes.READ_ALL_SUCCESS, props<{ users: UserQueryDto[] }>());
export const readAllFailed = createAction(UserActionTypes.READ_ALL_FAILED, props<{ error?: unknown }>());

export const createUser = createAction(UserActionTypes.CREATE_USER, props<{ newUser: any }>());
export const createUserSuccess = createAction(UserActionTypes.CREATE_USER_SUCCESS, props<{ newUser: any }>());
export const createUserFailed = createAction(UserActionTypes.CREATE_USER_FAILED, props<{ error?: unknown }>());

export const updateUser = createAction(UserActionTypes.UPDATE_USER, props<{ newUser: any }>());
export const updateUserSuccess = createAction(UserActionTypes.UPDATE_USER_SUCCESS);
export const updateUserFailed = createAction(UserActionTypes.UPDATE_USER_FAILED, props<{ error?: unknown }>());

export const adminUpdateUser = createAction(
  UserActionTypes.ADMIN_UPDATE_USER,
  props<{ userId: string; update: UserUpdateCommand }>()
);
export const adminUpdateUserSuccess = createAction(UserActionTypes.ADMIN_UPDATE_USER_SUCCESS);
export const adminUpdateUserFailed = createAction(
  UserActionTypes.ADMIN_UPDATE_USER_FAILED,
  props<{ error?: unknown }>()
);

export const resetUsers = createAction(UserActionTypes.RESET);
